import React, { useContext } from 'react'
import { NotificationsContext, TypeNotificationsContext } from '../contexts'

const useNotifications = (): TypeNotificationsContext => {
    return useContext(NotificationsContext)
}

export default useNotifications
